import {
    InputAdornment,
    Paper,
    TableBody,
    TableCell,
    TableRow,
    Toolbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { DeleteForeverOutlined, Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/Edit';
import EmojiPeopleOutlinedIcon from '@mui/icons-material/EmojiPeopleOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controls } from '../../components/controls/Controls';
import PageHeader from '../../components/PageHeader';
import Popup from '../../components/Popup';
import useTable from '../../components/useTable';
import { loadClientes, saveCliente } from '../../redux/ducks/clientes';
import ClientesForm from './ClientesForm';
import { setIndex } from '../../redux/ducks/sideMenuIndex';
import { dateAndTimeToMoment, filterOnAnyField } from '../../utils';
import ConfirmDialog from '../../components/ConfirmDialog';
import http from '../../http-common';

const useStyles = makeStyles((theme) => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
    },
    searchInput: {
        width: '75%',
    },
    newButton: {},
    refreshButton: {},
}));

const headCells = [
    { id: 'nombre', label: 'Nombre' },
    { id: 'rfc', label: 'RFC' },
    { id: 'razonSocial', label: 'Razon Social' },
    { id: 'correoContacto', label: 'Correo de Contacto' },
    { id: 'telefono', label: 'Teléfono' },
    { id: 'actions', label: 'Acciones', disableSorting: true },
];

export default function Clientes() {
    const [openPopup, setOpenPopup] = useState(false);
    const classes = useStyles();
    const [filterFn, setFilterFn] = useState({
        fn: (items) => items,
    });
    const [recordForEdit, setRecordForEdit] = useState();

    const clientes = useSelector((state) => state.clientes.clientes);

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    } = useTable(clientes, headCells, filterFn);

    const [filter, setFilter] = useState();

    const handleSearch = (e) => {
        const { target } = e;
        setFilter(target.value);

        setFilterFn({
            fn: (items) => {
                if (target.value === '') {
                    return items;
                }
                const filteredItems = filterOnAnyField(items, target.value.toLowerCase());
                return filteredItems;
            },
        });

        /* setFilterFn({
            fn: (items) => {
                if (target.value === '') {
                    return items;
                }
                return items.filter((x) =>
                    x.nombre.toLowerCase().includes(target.value.toLowerCase())
                );
            },
        }); */
    };
    const dispatch = useDispatch();

    const addOrEdit = (cliente, resetForm) => {
        dispatch(saveCliente(cliente));
        setOpenPopup(false);
        resetForm();
    };

    const openInPopup = (item) => {
        setRecordForEdit(item);
        setOpenPopup(true);
    };

    useEffect(() => {
        dispatch(loadClientes());
    }, [dispatch]);

    useEffect(() => {
        dispatch(setIndex(0, 'Cat'));
    }, [dispatch]);

    const [confirmDialog, setConfirmDialog] = useState({
        title: 'title',
        subtitle: 'subtitle',
        isOpen: false,
    });

    const deleteCliente = (item) => {
        setConfirmDialog({
            subtitle: '',
            title: 'Desea borrar el cliente?',
            isOpen: true,
            onConfirm: async () => {
                await http.delete(`/clientes/${item.id}`);
                dispatch(loadClientes());
            },
        });
    };
    return (
        <>
            <PageHeader
                icon={<EmojiPeopleOutlinedIcon fontSize='large' />}
                subtitle=''
                title='Clientes'
            />
            <Paper className={classes.pageContent}>
                <Toolbar>
                    <Controls.Input
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='end'>
                                    <Search />
                                </InputAdornment>
                            ),
                        }}
                        label='Buscar'
                        onChange={handleSearch}
                        value={filter}
                    />
                    <Controls.Button
                        className={classes.refreshButton}
                        startIcon={<RefreshIcon />}
                        text='Refrescar'
                        variant='outlined'
                    />
                    <Controls.Button
                        className={classes.newButton}
                        onClick={() => {
                            setRecordForEdit(null);
                            setOpenPopup(true);
                        }}
                        startIcon={<AddIcon />}
                        text='Agregar Nueva'
                        variant='outlined'
                    />
                </Toolbar>
                <TblContainer>
                    <TblHead />
                    <TableBody>
                        {recordsAfterPagingAndSorting().map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.nombre}</TableCell>
                                <TableCell>{item.rfc}</TableCell>
                                <TableCell>{item.razonSocial}</TableCell>
                                <TableCell>{item.correoContacto}</TableCell>
                                <TableCell>{item.telefono}</TableCell>
                                <TableCell>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => {
                                            openInPopup(item);
                                        }}
                                    >
                                        <EditOutlinedIcon fontSize='small' />
                                    </Controls.ActionButton>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => {
                                            deleteCliente(item);
                                        }}
                                    >
                                        <DeleteForeverOutlined fontSize='small' />
                                    </Controls.ActionButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                title='Cliente'
            >
                <ClientesForm
                    addOrEdit={addOrEdit}
                    recordForEdit={recordForEdit}
                />
            </Popup>

            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </>
    );
}
